import { useState, useEffect } from 'react'

import { useRouter } from 'next/router'

import { Locale, TeamNata } from '@/service/api/landingPage'
import { getLPTranslationData } from '@/utils/getLPTranslationData'

export const useTeamNataContainer = () => {
  const router = useRouter()
  const locale = (router.locale || 'pt-BR') as Locale

  const [teamNataData, setTeamNataData] = useState<TeamNata>(
    () =>
      getLPTranslationData({
        landingPage: 'software',
        container: 'teamNataContainer',
        locale,
      }) as TeamNata,
  )

  useEffect(() => {
    const translationsObject = getLPTranslationData({
      landingPage: 'software',
      container: 'teamNataContainer',
      locale,
    }) as TeamNata

    setTeamNataData(translationsObject)
  }, [locale])

  return {
    teamNataData,
  }
}
